import React from 'react';
import {Button, InfoMedia, ProgressOne, SecSubTitle, SecTitle, ServiceBoxThree} from '../../components';
import serviceData from "../../data/service.json";
import Slider from "react-slick";

const AboutTwoEInvoiceSection = ({restProps})=> (
    <div {...restProps}>
      <div className="container">
        <div className="row flex-row-reverse">
          <div className="col-lg-5 col-xxl-auto mb-30 pb-20 pb-lg-0">
            <img style={{height:700,width:'auto'}} src="images/e-invoice/e-invoice-9.png" alt="Skill"/>
          </div>
          <div className="col-lg-7 col-xxl-6 me-xl-auto">
            <SecSubTitle><i className="fas fa-bring-forward"/>Smarter, Safer, Stronger</SecSubTitle>
            <SecTitle className="h1">E-Invoicing</SecTitle>
            <p className="mb-4 pb-1">E-Invoicing is the secure, automated digital exchange of invoices between businesses and tax authorities. It replaces traditional paper-based methods to enhance compliance, reduce fraud, and improve tax efficiency. As global mandates evolve, adopting a future-proof solution is essential.</p>
            <div className="row">
              <div className="col-md-6 col-lg-6" key={1}>
                <ServiceBoxThree path={'/e-invoicing-for-ksa'}
                                 image={'/images/e-invoice/map-ksa.png'}
                                 icon={'/images/e-invoice/e-invoice-zatka.png'}
                                 title={"KSA (ZATCA Compliance)"}
                                 text={"Compliant with Phase 1 and Phase 2 of ZATCA rules, including QR codes, UUIDs, and e-signatures."}
                />
              </div>
              <div className="col-md-6 col-lg-6" key={2}>
                <ServiceBoxThree path={'/e-invoicing-for-uae'}
                                 image={'/images/e-invoice/map-uae.png'}
                                 icon={'/images/e-invoice/e-invoice-fta.png'}
                                 title={"UAE (FTA Readiness)"}
                                 text={"Built to support FTA’s upcoming E-Invoicing mandates, ensuring seamless compliance and digital invoice readiness."}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
);

export default AboutTwoEInvoiceSection;